import { Tabs } from 'antd';

export const TabbedContainer = props => {
  return (
    <Tabs
      defaultActiveKey={props.defaultActiveKey}
      destroyInactiveTabPane={props.destroyInactiveTabPane}
      onChange={props.onChange}
      onTabClick={props.onTabClick}
      activeKey={props.activeKey}
    >
      {props.children}
    </Tabs>
  );
};

export const TabPane = props => {
  return <Tabs.TabPane {...props} />;
};
